var render = function render(){
  var _vm$formFields;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-content"
  }, [_c('div', {
    staticClass: "upload-description"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('div', {
    staticClass: "upload-area",
    class: {
      'upload-area-dragging': _vm.isDragging
    },
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
        _vm.isDragging = true;
      },
      "dragleave": function ($event) {
        $event.preventDefault();
        _vm.isDragging = false;
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.onFileDrop.apply(null, arguments);
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "upload-icon mb-4 opacity-50",
    attrs: {
      "icon": "cloud-upload"
    }
  }), _c('div', {
    staticClass: "upload-text"
  }, [_vm._m(0), _c('input', {
    staticClass: "d-none",
    attrs: {
      "id": "file-upload",
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]), _vm.selectedFile ? _c('div', {
    staticClass: "selected-file"
  }, [_vm._v(" Geselecteerd bestand: " + _vm._s(_vm.selectedFile.name) + " ")]) : _vm._e()], 1), _vm.isUploading ? _c('div', {
    staticClass: "loading-container"
  }, [_c('div', {
    staticClass: "loading-content"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }), _c('span', [_vm._v("Bestand wordt geüpload...")])], 1)]) : _vm._e(), _vm.selectedFile !== null ? _c('div', {
    staticClass: "button-container"
  }, [_c('b-button', {
    attrs: {
      "icon": "faUndo"
    },
    on: {
      "click": _vm.resetUpload
    }
  }, [_c('FontAwesomeIcon', {
    staticClass: "ml-1",
    attrs: {
      "icon": "undo"
    }
  }), _vm._v(" Nieuw bestand uploaden ")], 1)], 1) : _vm._e(), ((_vm$formFields = _vm.formFields) === null || _vm$formFields === void 0 ? void 0 : _vm$formFields.length) > 0 ? _c('div', [_vm._l(_vm.formFields, function (formField, index) {
    return _c('b-row', {
      key: index,
      staticClass: "mb-1"
    }, [_c('b-col', {
      attrs: {
        "sm": "2"
      }
    }, [_c('label', {
      attrs: {
        "for": formField.name
      }
    }, [_vm._v(_vm._s(formField.title))])]), _c('b-col', {
      attrs: {
        "sm": "2"
      }
    }, [_c('b-input', {
      staticClass: "d-inline-block mr-2",
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "type": "text",
        "placeholder": formField.placeholder
      },
      model: {
        value: formField.value,
        callback: function ($$v) {
          _vm.$set(formField, "value", $$v);
        },
        expression: "formField.value"
      }
    })], 1)], 1);
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('OmniButton', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": !_vm.isFormComplete && !_vm.isUploading
    },
    on: {
      "click": function ($event) {
        return _vm.processFile(true);
      }
    }
  }, [_vm._v("Upload")])], 1)], 1)], 2) : _vm._e(), _vm.instructions && _vm.instructions.length > 0 && !_vm.isFormComplete ? _c('div', {
    staticClass: "alert alert-info instructions"
  }, [_c('h4', {
    staticClass: "instructions-title"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "circle-info"
    }
  }), _vm._v(" Instructies ")], 1), _c('ul', {
    staticClass: "instructions-list"
  }, _vm._l(_vm.instructions, function (instruction, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(instruction))]);
  }), 0)]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "upload-label",
    attrs: {
      "for": "file-upload"
    }
  }, [_c('span', {
    staticClass: "upload-link"
  }, [_vm._v(" Klik hier om een bestand te selecteren ")]), _c('span', {
    staticClass: "upload-hint"
  }, [_vm._v(" of sleep het bestand hierheen")])]);

}]

export { render, staticRenderFns }